import { Benefits } from "../Benefits";
import { Solutions } from "../Solutions";
import { Features } from "../Features";
import { AIAdvancements } from "../AIAdvancements";
import { WhyChooseUs } from "../WhyChooseUs";
import { ClientResults } from "../ClientResults";

export function Home() {
  return (
    <>
      <Benefits />
      <Solutions />
      <Features />
      <AIAdvancements />
      <WhyChooseUs />
      <ClientResults />
    </>
  );
}